import React from "react";

export class ReCaptcha extends React.Component {


    constructor(props) {
        super(props);

        this.recaptchaContainerRef = React.createRef();
    }

    shouldComponentUpdate() {
        return false;
    }

    componentDidMount() {
        const script = document.createElement("script");
        script.src = "https://www.recaptcha.net/recaptcha/api.js?onload=onloadCallbackRecaptcha&render=explicit";
        script.async = true;
        document.body.appendChild(script);

        window.onloadCallbackRecaptcha = () => {
            grecaptcha.render(this.recaptchaContainerRef.current, {
                'sitekey': casino.config.recaptchaSiteKey,
                'callback': this.props.updateCaptchaFn,
                'expired-callback': this.props.updateCaptchaFn
            });
        };
    }

    render() {
        return <div id="recaptchaContainer" className="recaptchaContainer" ref={this.recaptchaContainerRef} />;
    }
};
